module.exports = __webpack_public_path__ + "static/media/tarde.b40c175d.svg";